import type { Group, Scene } from 'three';
import { trafficMesh } from '../entities/vehicles/catalog';
import { junctionAt } from '../systems/junctions/signals';
import type { CrossCar } from './RunState';

/** Meshes for cars on the crossing roads, turned side-on to our road. */
export class CrossTrafficView {
  private readonly meshes = new Map<number, Group>();

  constructor(private readonly scene: Scene) {}

  sync(cars: readonly CrossCar[]): void {
    const alive = new Set<number>();
    for (const car of cars) {
      alive.add(car.id);
      let mesh = this.meshes.get(car.id);
      if (!mesh) {
        mesh = trafficMesh(car.kind, car.variant);
        this.meshes.set(car.id, mesh);
        this.scene.add(mesh);
      }
      mesh.position.set(car.x, 0, -(junctionAt(car.junctionSeq).position + car.laneOffset));
      // Models face -z; turn them to face along the crossing road (plus any swing from a crash).
      mesh.rotation.y = (car.dir === 1 ? -Math.PI / 2 : Math.PI / 2) + (car.spin ?? 0);
    }
    for (const [id, mesh] of this.meshes) {
      if (alive.has(id)) continue;
      this.scene.remove(mesh);
      this.meshes.delete(id);
    }
  }

  clear(): void {
    for (const mesh of this.meshes.values()) this.scene.remove(mesh);
    this.meshes.clear();
  }
}
